import RecognitionLogin from "./RecognitionLogin";

export default RecognitionLogin;
